// Months array for dropdown
const months = [
  { value: "01", label: "January" },
  { value: "02", label: "February" },
  { value: "03", label: "March" },
  { value: "04", label: "April" },
  { value: "05", label: "May" },
  { value: "06", label: "June" },
  { value: "07", label: "July" },
  { value: "08", label: "August" },
  { value: "09", label: "September" },
  { value: "10", label: "October" },
  { value: "11", label: "November" },
  { value: "12", label: "December" },
];

// Vehicle Make & Model data
const vehicleData = [
  // TVS Data
  {
    ID_PK: 6825,
    Value: "TVS | APACHE | 150 | CC/WATT 160",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "TVS",
    VehicleModel: "APACHE 150",
    Variance: null,
    CC: 160,
    Cubic_Capacity: 160,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 52920,
    Value: "TVS | APACHE | 160 RTR 4V SPECIAL EDITION | CC/WATT 160",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "TVS",
    VehicleModel: "APACHE 160 RTR 4V SPECIAL EDITION",
    Variance: null,
    CC: 160,
    Cubic_Capacity: 160,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 14940,
    Value: "TVS | APACHE | 160 RTR ES | CC/WATT 160",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "TVS",
    VehicleModel: "APACHE 160 RTR ES",
    Variance: null,
    CC: 160,
    Cubic_Capacity: 160,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 14941,
    Value: "TVS | APACHE | 160 RTR ES UPGRADE | CC/WATT 160",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "TVS",
    VehicleModel: "APACHE 160 RTR ES UPGRADE",
    Variance: null,
    CC: 160,
    Cubic_Capacity: 160,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 39974,
    Value: "TVS | APACHE | 160 RTR SPECIAL EDITION | CC/WATT 160",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "TVS",
    VehicleModel: "APACHE 160 RTR SPECIAL EDITION",
    Variance: null,
    CC: 160,
    Cubic_Capacity: 160,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  // HERO HONDA Data
  {
    ID_PK: 939,
    Value: "HERO HONDA | ACHIEVER | 150 | CC/WATT 150",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "HERO HONDA",
    VehicleModel: "ACHIEVER 150",
    Variance: null,
    CC: 150,
    Cubic_Capacity: 150,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 70024,
    Value: "HERO HONDA | ACHIEVER | 150 DRUM | CC/WATT 149",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "HERO HONDA",
    VehicleModel: "ACHIEVER 150 DRUM",
    Variance: null,
    CC: 149,
    Cubic_Capacity: 149,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 938,
    Value: "HERO HONDA | ACHIEVER | 150 KS | CC/WATT 150",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "HERO HONDA",
    VehicleModel: "ACHIEVER 150 KS",
    Variance: null,
    CC: 150,
    Cubic_Capacity: 150,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 14814,
    Value: "HERO HONDA | ACHIEVER | DISC KICK | CC/WATT 150",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "HERO HONDA",
    VehicleModel: "ACHIEVER DISC KICK",
    Variance: null,
    CC: 150,
    Cubic_Capacity: 150,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 14815,
    Value: "HERO HONDA | ACHIEVER | DISC SELF | CC/WATT 150",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "HERO HONDA",
    VehicleModel: "ACHIEVER DISC SELF",
    Variance: null,
    CC: 150,
    Cubic_Capacity: 150,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
  {
    ID_PK: 947,
    Value: "HERO HONDA | ACHIEVER | ES DISC BRAKE | CC/WATT 150",
    ID_FK: 0,
    ID_Sum: null,
    Code: null,
    VehicleMake: "HERO HONDA",
    VehicleModel: "ACHIEVER ES DISC BRAKE",
    Variance: null,
    CC: 150,
    Cubic_Capacity: 150,
    LCC: 0,
    ExshowRoomPrice: 0,
    GrossVehicleWeight: null,
    NumberofWheels: 2,
    Seating_Capacity: 2,
    Zone: null,
    City_or_Village_ID_PK: 0,
    Model_ID_PK: 0,
    Text: null,
    ZoneError: null,
    Survey: 0,
    Bodyprice: null,
    ChasisPrice: null,
    VehicleCategory: null,
    VehicleUsageType: null,
    VehicleSubUsageType: null,
    MaxCarryingCapacity: null,
    MinCarryingCapacity: null,
    PCVMaxCarryingCapacity: null,
    PCVMinCarryingCapacity: null,
    MinLength: null,
    MaxLength: null,
    CoverName: null,
    ViewName: null,
    CoverID: 0,
    IfoundaryCover: null,
    Status: false,
    dbCoverName: null,
    IfoundaryCoverName: null,
    IfoundaryViewName: null,
    BranchName: null,
    EmployeeName: null,
    EmployeeCode: null,
    StateRegionRto: null,
    ShowRoomPrice: null,
    Channel: null,
    ChannelCode: null,
    TravelPlanProductName: null,
    TravelPlanProductCode: null,
    DiseaseName: null,
    DiseaseId: 0,
    GeoExtensionName: null,
    GeoExtensionId: 0,
    RelationName: null,
    RelationId: 0,
    description: null,
    TpaId: 0,
    TpaName: null,
    PlanId: 0,
    PlanName: null,
    MarineTypeID: 0,
    ItemDescription: null,
    MasterTypeID: null,
    AreaID: 0,
    Pincode: null,
    IsSelected: false,
    ProductCode: null,
    ddlseatingCapacity: null,
    VehicleSegmentCode: null,
    VehicleSegmentName: null,
    PolicyStartDate: null,
    PolicyEndDate: null,
    stringValue: null,
    TxtCategory: null,
  },
];

export {
    months,
    vehicleData
}
